import { QueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { REQUEST_RETRY_COUNT } from '@/utils/config'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      onError: (error) => {
        toast.error(error.message)
        console.error(error)
      },
      retryDelay: (attempt) => attempt,
      retry: (failureCount, data) => {
        if (data?.response?.status === 401 || data?.response?.status === 403) {
          return false
        }
        return failureCount + 1 < REQUEST_RETRY_COUNT
      },
    },
    mutations: {
      onError: (error) => {
        toast.error(error.message)
        console.error(error)
      },
    },
  },
})

export default queryClient
